import {  useState } from "react";
import { useTranslation } from "react-i18next";
// import i18next from "i18next";

// const languageMap = {
//   en: { label: "English",  active: true },
//   ar: { label: "العربية", active: false },
// };

const SecHeader = ({ Logo, MenuInfo }) => {
  const { i18n } = useTranslation();
  // const selected = localStorage.getItem("i18nextLng") || "en";
  const { t } = useTranslation();
  // const [menuAnchor, setMenuAnchor] = useState(null);
  // useEffect(() => {
  //   document.body.dir = languageMap[selected].dir;
  // }, [menuAnchor, selected]);

  const [SelectedLang, setSelectedLang] = useState("en");
const handleClick =(lang) =>{
  i18n.changeLanguage(lang);
}
  return (
    <nav className="navbar navbar-expand-lg navbar-white fixed-top" id="banner">
      <div className="container">
        {/* Brand */}
        <a className="navbar-brand" href="./">
          <span>
            <img draggable="false" src={Logo} alt="logo" />
          </span>
        </a>
        {/* Toggler/collapsibe Button */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>
        {/* Navbar links */}

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto">
            {/* {MenuInfo &&
              MenuInfo.map((item, key) => (
                <li className="nav-item" key={key}>
                  <a className="nav-link" href={item.path}>
                    {item.nameLink}
                  </a>
                </li>
              ))} */}
              <li className="nav-item" >
                  <a className="nav-link" href="#about">
                  {t('navbar.1')}
                  </a>
                </li>
                <li className="nav-item" >
                  <a className="nav-link" href="#services">
                  {t('navbar.2')}
                  </a>
                </li> <li className="nav-item" >
                  <a className="nav-link" href="#products">
                  {t('navbar.3')}
                  </a>
                </li><li className="nav-item" >
                  <a className="nav-link" href="#team">
                  {t('navbar.4')}
                  </a>
                </li>
                
              {SelectedLang === "en"?(
                            <li className="lh-55px"><button className="btn login-btn ml-30" onClick={()=>{setSelectedLang('ar');handleClick('ar') }}>Ar</button></li>

              ):(            <li className="lh-55px"><button className="btn login-btn ml-30" onClick={()=>{setSelectedLang('en');handleClick('en')}}>En</button></li>
              )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default SecHeader;
